import { render, staticRenderFns } from "./DesignerOrders.vue?vue&type=template&id=a589063a&scoped=true&"
import script from "./DesignerOrders.vue?vue&type=script&lang=js&"
export * from "./DesignerOrders.vue?vue&type=script&lang=js&"
import style0 from "./DesignerOrders.vue?vue&type=style&index=0&id=a589063a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a589063a",
  null
  
)

export default component.exports